export enum Environment {
  DEV = 'DEV',
  UAT = 'UAT',
  PROD = 'PROD',
}
